<template>
  <!-- 设备 -->
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">日志服务</div>
      
        <div class="main-center paddingTop-no">
          <span v-if="activeName==='0'">
            <v-input
              class=""
              v-model="searchValue"
              placeholder="请输入搜索内容"
              suffix-icon="v-icon-search"
              @change="(v) => searchValue = v"
            ></v-input>
          </span>
          <span v-else>
            <span>产品：</span
            ><v-select
              class="align-middle"
              id="product"
              @change="getDevList"
              name="product"
              v-model="productKey"
              :options="productOptions"
            ></v-select>
            <span v-if="activeName != '2'" class="ml10">设备： </span>
            <v-select1
              isSearch
              @searchData="changeSearch"
              :disabled="deviceOptions.length === 0"
              v-if="activeName != '2'"
              class="align-middle"
              id="deviceKey"
              name="deviceKey"
              v-model="deviceKey"
              :options="deviceOptions"
            >
            </v-select1>
          </span>
         
          <v-button class="ml10" type="primary" name="" @click="handleSearch">查询</v-button>
          <v-button class="" type="info" name="" @click="clear">重置</v-button>
        </div>
      </div>
      <v-row class="tabs-demo__size" >
        <v-col :span="22" >
          <v-tabs v-model="activeName" size="S" name="tabs-s-card" type="card" >
            <v-tab-pane label="强制升级日志" value="0">
              <ForceUpgradeLog
                :searchValue="searchValue"
                :productKey="productKey"
                :deviceKey="deviceKey"
                ref="ForceUpgradeLog"
              ></ForceUpgradeLog>
            </v-tab-pane>
            <v-tab-pane label="云端运行日志" value="1">
              <OnlineOperationLog
                :productKey="productKey"
                :deviceKey="deviceKey"
                ref="OnlineOperationLog"
              ></OnlineOperationLog>
            </v-tab-pane>
            <v-tab-pane label="设备上报结果" value="3">
              <ReportList
                :productKey="productKey"
                :deviceKey="deviceKey"
                ref="ReportList"
              ></ReportList>
            </v-tab-pane>
            <v-tab-pane label="设备本地日志" value="2">
              <DeviceLocalLog
                :productKey="productKey"
                :deviceKey="deviceKey"
                ref="DeviceLocalLog"
              ></DeviceLocalLog>
            </v-tab-pane>
          </v-tabs>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ForceUpgradeLog from "@/components/log-service/force-upgrade-log.vue";
import OnlineOperationLog from "@/components/log-service/online-operation-log.vue";
import DeviceLocalLog from "@/components/log-service/device-local-log.vue";
import ReportList from "@/components/log-service/device-report-list.vue";
export default {
  components: { ForceUpgradeLog, OnlineOperationLog, DeviceLocalLog, ReportList },
  data() {
    return {
      activeName: "0",
      productKey: "",
      deviceKey: "",
      productOptions: [],
      deviceOptions: [],
      searchDevName: "",
      searchValue: ""
    };
  },
  created() {
    this.getProductList()
  },
  watch: {
    activeName: {
      handler() {
        this.changeclear()
      },
      immediate: true
    }
  },
  methods: {
    changeSearch(data) {
      this.searchDevName = data;
      this.getDevList();
    },
    handleSearch(){
      if(this.activeName == '3' && this.deviceKey == ''){
        this.$message.warn(_("请选择设备进行查询"))
        return
      }
      // if(this.activeName == '2' && this.productKey == ''){
      //   this.$message.warn(_("请选择产品进行搜索"))
      //   return
      // }
      this.search()
    },
    clear () {
      this.productKey = ''
      this.deviceKey = ''
      this.deviceOptions = []
      this.searchValue = ""
      setTimeout(() => {
        this.search()
      },100)
    },
    changeclear () {
      this.productKey = ''
      this.deviceKey = ''
      this.deviceOptions = []
    },
    search () {
      if (this.activeName == '0') {
        let searchData = this.searchValue
        if (this.searchValue === "基于设备SN") {
          searchData = "basesn";
        } else if (this.searchValue === "基于产品名称") {
          searchData = "baseproduct";
        }
        this.$refs.ForceUpgradeLog.getData(searchData)
      } else if (this.activeName == '1') {
        this.$refs.OnlineOperationLog.search()
      } else if (this.activeName == '2'){
        this.$refs.DeviceLocalLog.getData()
      } else{
        this.$refs.ReportList.getData()
      }
    },
    getProductList() {
      const submitData = {
        app_id: sessionStorage.getItem("appid") || "",
      };
      this.$post(
        "/td/td-iot-api/iot/common/product/list/v1",
        submitData,
        false
      ).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.productOptions = res.data.map((item) => {
            return {
              label: item.product_name,
              value: item.product_key,
            };
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getDevList() {
      this.deviceKey = "";
      const submitData = {
        app_id: sessionStorage.getItem("appid") || "",
        product_key: this.productKey,
        size: 1000,
        dev_name: this.searchDevName,
      };
      this.$post(
        "/td/td-iot-api/iot/common/dev/list/v1",
        submitData,
        false
      ).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.deviceOptions = res.data.map((item) => {
            return {
              label: item.dev_name,
              value: item.dev_key,
            };
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      // this.searchDevName = "";
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
</style>
